const GET_USERS = "GET_USERS";
const GET_USERS_SUCCESS = "GET_USERS_SUCCESS";
const GET_USERS_ERROR = "GET_USERS_ERROR";
const ADD_USERS = "ADD_USERS";
const ADD_USERS_SUCCESS = "ADD_USERS_SUCCESS";
const ADD_USERS_ERROR = "ADD_USERS_ERROR";
const EDIT_USERS = "EDIT_USERS";
const EDIT_USERS_SUCCESS = "EDIT_USERS_SUCCESS";
const EDIT_USERS_ERROR = "EDIT_USERS_ERROR";
const FORGOT_PWD = "FORGOT_PWD";
const FORGOT_PWD_SUCCESS = "FORGOT_PWD_SUCCESS";
const FORGOT_PWD_ERROR = "FORGOT_PWD_ERROR";
const ADD_AZURE_ACCOUNT = "ADD_AZURE_ACCOUNT";
const ADD_AZURE_ACCOUNT_SUCCESS = "ADD_AZURE_ACCOUNT_SUCCESS";
const ADD_AZURE_ACCOUNT_ERROR = "ADD_AZURE_ACCOUNT_ERROR";
export {
  GET_USERS,
  GET_USERS_SUCCESS,
  GET_USERS_ERROR,
  ADD_USERS,
  ADD_USERS_SUCCESS,
  ADD_USERS_ERROR,
  EDIT_USERS,
  EDIT_USERS_SUCCESS,
  EDIT_USERS_ERROR,
  FORGOT_PWD,
  FORGOT_PWD_ERROR,
  FORGOT_PWD_SUCCESS,
  ADD_AZURE_ACCOUNT,
  ADD_AZURE_ACCOUNT_SUCCESS,
  ADD_AZURE_ACCOUNT_ERROR,
};
